import type { TrackedPrompt } from '../types'

const key = (identity: string) => `mugen2.promptRefs.${identity || 'local'}`

export function readTrackedPrompts(identity: string): TrackedPrompt[] {
  try {
    const value = JSON.parse(localStorage.getItem(key(identity)) || '[]') as unknown
    if (!Array.isArray(value)) return []
    return value.filter((item): item is TrackedPrompt => {
      if (!item || typeof item !== 'object') return false
      const record = item as Record<string, unknown>
      return typeof record.promptId === 'string'
        && typeof record.serverId === 'string'
        && typeof record.createdAt === 'number'
    }).slice(-100)
  } catch {
    return []
  }
}

export function trackPrompt(identity: string, prompt: TrackedPrompt): void {
  const current = readTrackedPrompts(identity)
    .filter((item) => !(item.promptId === prompt.promptId && item.serverId === prompt.serverId))
  localStorage.setItem(key(identity), JSON.stringify([...current, prompt].slice(-100)))
}

export function updateTrackedPrompt(
  identity: string,
  serverId: string,
  promptId: string,
  patch: Partial<TrackedPrompt>,
): void {
  const current = readTrackedPrompts(identity)
  const updated = current.map((item) => item.serverId === serverId && item.promptId === promptId
    ? { ...item, ...patch }
    : item)
  localStorage.setItem(key(identity), JSON.stringify(updated))
}

export function removeTrackedPrompts(identity: string, promptIds: string[]): void {
  if (!promptIds.length) return
  const removed = new Set(promptIds)
  localStorage.setItem(key(identity), JSON.stringify(
    readTrackedPrompts(identity).filter((item) => !removed.has(item.promptId)),
  ))
}
